module.exports = __webpack_public_path__ + "static/media/27_plantilla_cuadrada_combo_simple_cf_stills_pet_2,25L_aq_pera.6e1f2b7f.png";